import { useQuery } from 'react-query';

import { Chronology } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetChronologiesForSubset = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Chronology[]>(
    [QueryEntity.Chronologies, { subsetId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/chronology`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!subsetId },
  );
};
